// react
import { useContext } from 'react';

// context
import { ContextEntityNonCashBenefits } from '../Entity.context';

// mui
import { Container, Grid } from '@mui/material';

// tables
import { TableNonCashBenefits } from '../../../tables/cards/TableNonCashBenefits/TableNonCashBenefits';

export const NonCashBenefits = () => {
	// context
	const {
		isLoadingNonCashBenefits,
		nonCashBenefits,
		paginationNonCashBenefits,
		refetchNonCashBenefits,
	} = useContext(ContextEntityNonCashBenefits);

	return (
		<Container maxWidth={false}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<TableNonCashBenefits
						frame="ENTITY"
						isLoading={isLoadingNonCashBenefits}
						pagination={paginationNonCashBenefits}
						refetchTransactions={refetchNonCashBenefits}
						transactions={nonCashBenefits}
					/>
				</Grid>
			</Grid>
		</Container>
	);
};
